// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ff69abc40fb202a7b80d","3881":"9dd7dd59b7bfc5a5a7a8"}[chunkId] + ".css";
};